import {Construtor} from './construtor';

export class AreaParametroGrafico implements Construtor<AreaParametroGrafico> {
  public idAreaParametroGrafico: number;
  public idParametroGrafico: number;
  public idAreaCliente: number;
  public alterado: boolean;

  constructor(object?: any) {

    if (object !== undefined) {

      if (object instanceof AreaParametroGrafico) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }

    }

    return this;
  }

  copyObject(area: AreaParametroGrafico): void {
    this.idAreaParametroGrafico = area.idAreaParametroGrafico;
    this.idParametroGrafico = area.idParametroGrafico;
    this.idAreaCliente = area.idAreaCliente;
  }

  parseFromJson(area: any): void {
    this.idAreaParametroGrafico = area.idAreaParametroGrafico;
    this.idParametroGrafico = area.idParametroGrafico;
    this.idAreaCliente = area.idAreaCliente;
  }

  modeloCompleto(): boolean {
    return this.idAreaCliente !== undefined;
  }

  getNewInstance(object?: any): AreaParametroGrafico {
    return new AreaParametroGrafico(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/area-parametro-grafico.ts